// Builds avatar initials from a name.
//
// Naive `split(" ").map(s => s[0])` breaks on names like "Monika Głazowska - Pawłowska":
// the standalone hyphen becomes its own "initial", rendering "MG - P" and blowing out the
// avatar. Split on whitespace AND hyphens, keep only word characters, cap the result so a
// long name cannot stretch the circle.
const MAX_INITIALS = 3;

const initials = (name, fallback = "") => {
  const source = (name || "").trim();

  if (!source) {
    return fallback ? fallback.trim().charAt(0).toUpperCase() : "";
  }

  const letters = source
    .split(/[\s\-_/]+/)
    .map((part) => part.replace(/[^\p{L}\p{N}]/gu, ""))
    .filter((part) => part.length > 0)
    .map((part) => part.charAt(0).toUpperCase());

  if (letters.length === 0) {
    return fallback ? fallback.trim().charAt(0).toUpperCase() : "";
  }

  return letters.slice(0, MAX_INITIALS).join("");
};

export default initials;
